<template>
	<div>
		<core-stakeholders-card
			:transactionId="transactionId"
			:stakeholders="stakeholders"
			stakeholdersOf="transaction"
			:types="types"
			@stakeholder:added="fetchStakeholders"
			@stakeholder:removed="removeStakeholder"
		/>
	</div>
</template>

<script>
import CoreStakeholdersCard from "@/modules/core/components/CoreStakeholdersCard/"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { CoreStakeholdersCard },

	props: {
		transactionId: {
			type: String
		}
	},

	data() {
		return {
			stakeholders: [],
			types: [
				{ name: "Company", value: "company" },
				{ name: "Business Unit", value: "businessUnit" },
				{ name: "Policyholder", value: "policyHolder" },
				{ name: "Insured", value: "insured" },
				{ name: "Mother Company", value: "motherCompany" },
				{ name: "Contact Name", value: "contactName" },
				{ name: "Underwriter", value: "underwriter" },
				{ name: "London Broker", value: "londonBroker" },
				{ name: "Broker", value: "broker" },
				{ name: "Handled By", value: "handledBy" },
				{ name: "Signed By", value: "signedBy" },
				{ name: "Agency", value: "agency" },
				{
					name: "Third Party Referral - Company",
					value: "thirdPartyReferralCompany"
				},
				{
					name: "Third Party Referral - Individual",
					value: "thirdPartyReferralIndividual"
				},
				{ name: "Salesman", value: "salesman" },
				{ name: "Local Sub-Producer", value: "localSubProducer" },
				{ name: "Coverholder", value: "coverholder" },
				{ name: "Loss Adjuster", value: "lossAdjuster" },
				{ name: "Solicitor", value: "solicitor" },
				{ name: "Recovery From Party", value: "recoveryFromParty" }
			]
		}
	},

	methods: {
		async fetchStakeholders() {
			const query = gql`
				query transactionStakeholders($where: transactionWhereInput) {
					transactions(where: $where) {
						list {
							stakeholders {
								id
								type
								entity {
									id
									name
								}
							}
						}
					}
				}
			`

			const res = await api({
				query,
				variables: { where: { id: this.transactionId } }
			})

			this.stakeholders = res?.data?.transactions?.list?.[0]?.stakeholders
		},

		removeStakeholder(stakeholderId) {
			this.stakeholders = this.stakeholders.filter(
				item => item.id !== stakeholderId
			)
		}
	},

	mounted() {
		this.fetchStakeholders()
	}
}
</script>
